import React from 'react'

const Icon = () => (
  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 16.5C10.8 16.5 10.2083 16.2583 9.725 15.775C9.24167 15.2917 9 14.7 9 14C9 13.3 9.24167 12.7083 9.725 12.225C10.2083 11.7417 10.8 11.5 11.5 11.5C12.2 11.5 12.7917 11.7417 13.275 12.225C13.7583 12.7083 14 13.3 14 14C14 14.7 13.7583 15.2917 13.275 15.775C12.7917 16.2583 12.2 16.5 11.5 16.5ZM2 20.5C1.45 20.5 0.979 20.3043 0.587 19.913C0.195667 19.521 0 19.05 0 18.5V4.5C0 3.95 0.195667 3.47933 0.587 3.088C0.979 2.696 1.45 2.5 2 2.5H3V0.5H5V2.5H13V0.5H15V2.5H16C16.55 2.5 17.021 2.696 17.413 3.088C17.8043 3.47933 18 3.95 18 4.5V18.5C18 19.05 17.8043 19.521 17.413 19.913C17.021 20.3043 16.55 20.5 16 20.5H2ZM2 18.5H16V8.5H2V18.5ZM2 6.5H16V4.5H2V6.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon
